module.exports = __webpack_public_path__ + "img/dynameat-logo-secondary.cde813ed.png";